import { createFileRoute } from "@tanstack/react-router";

import { ProfilePage } from "../features/profile";

/** The public profile. Reachable by anyone holding the handle, and never behind a session. */
export const Route = createFileRoute("/u/$handle")({
  component: ProfileRoute,
});

function ProfileRoute() {
  const { handle } = Route.useParams();
  return <ProfilePage handle={handle} />;
}
